class DataLayer {
  public push(hash: {}) {
    if ((typeof window === 'undefined') ||
        (typeof (window as any).dataLayer === 'undefined')) {
      console.log(JSON.stringify(hash));
    } else {
      (window as any).dataLayer.push(hash);
    }
  }
}

export const dataLayer = new DataLayer();
